<template>
  <FormItem :name="name">
    <input
      type="email"
      v-model.trim="model"
      :readonly="readonly"
      :disabled="disabled"
      :placeholder="placeholder"
    />
  </FormItem>
</template>

<script setup lang="ts">
import FormItem from './Form-item.vue'
const props = defineProps({
  name: { type: String, required: true },
  placeholder: { type: String },
  disabled: { type: Boolean },
  readonly: { type: Boolean }
  // type: { type: String }
})

const model = defineModel<any>({ required: true })
</script>
